module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/monitoring/actual/badpress/badpressmatch/updatebadpressmatch/update-bad-press-match.component.html
// module id = 2229
// module chunks = 0